import { FaIcon } from '@ifixit/ui/components/icon';
import type { ReactNode } from 'react';

interface FormErrorProps {
   children?: ReactNode;
}

export function FormError(props: FormErrorProps) {
   if (!props.children) {
      return null;
   }

   return (
      <div className="flex items-center gap-2 text-red-500 text-sm font-normal my-2 text-left">
         <FaIcon name="circle-exclamation" className="size-4" />
         {props.children}
      </div>
   );
}
